import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class LancamentosRejeitadosValorPreService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getDataGoApi(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi
      .fetchLancamentosRejeitadosValorPre({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
      })
      .pipe(
        map(data => ({
          items: data.items ?? [],
        })),
        catchError(() => of({ items: [] })),
      );
  }
}
